import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useI18n from '@/composables/useI18n'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CancelInviteNotification',
  props: {
    cancellingUserInvite: {
      type: Boolean,
      default: false,
    },
    cancellationMessage: {
      type: String,
      default: '',
    },
  },
  emits: ['cancel', 'proceed'],
  setup(__props) {

const props = __props;

  

  

  const { translateString } = useI18n()

  const cancelMessage = computed(() =>
    props.cancellationMessage ? props.cancellationMessage : translateString('homepage.cancellationMessage'),
  )

return { __sfc: true,props, translateString, cancelMessage, computed, KetchUpButton, LoadingSpinner, useI18n }
}

})